<template>
  <div>
    <div class="flex items-center justify-between mb-5">
      <span class="text-xl font-bold">
        {{ $t('menu') }}
      </span>
      <ClientMobileOnly>
        <CloseNavigation />
      </ClientMobileOnly>
    </div>
    <div class="mb-4 text-base font-bold text-EXPONDO-black">
      {{ $t('Our products') }}
    </div>
    <NavSidebarCategoriesList
      :first-level-categories="firstLevelCategories"
    />
    <NavFooterLinks />
  </div>
</template>

<script lang="ts">

import type { Category } from '~~/types/commercetools';

export default defineComponent({
  name: 'NavSidebar',

  props: {
    firstLevelCategories: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];
      
      },
    },
  },
  setup() {

    const { toggleNavigation } = useNavigationState();

    return {
      toggleNavigation,
    };
  
  },
});

</script>
